import { Modal, Select, Space, Typography } from "antd";
import { WarningOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import axiosInstance from "../../../variables/api/axiosInstance";

const { Text } = Typography;

const FixEnginCategorieModal = ({
    open,
    enginCodeId,
    immatriculation,
    onFixed,
    onClose,
}) => {
    const [categories, setCategories] = useState([]);
    const [selectedCode, setSelectedCode] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (open) {
            axiosInstance.get("/api/categorie").then((res) => setCategories(res.data));
            setSelectedCode(null);
        }
    }, [open]);

    const handleOk = async () => {
        if (!selectedCode) return;
        if (!enginCodeId || enginCodeId === "null") {
            // Aucun engin identifiable : impossible de patcher une catégorie (évite /api/engin/null/...).
            return;
        }
        setLoading(true);
        try {
            await axiosInstance.patch(`/api/engin/${enginCodeId}/categorie/${selectedCode}`);
            onFixed();
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            open={open}
            title={
                <Space>
                    <WarningOutlined style={{ color: "#faad14" }} />
                    Catégorie manquante pour l'engin
                </Space>
            }
            okText="Enregistrer et valider"
            cancelText="Annuler"
            okButtonProps={{ disabled: !selectedCode, loading }}
            onOk={handleOk}
            onCancel={onClose}
            destroyOnClose
        >
            <Space direction="vertical" style={{ width: "100%" }}>
                <Text>
                    L'engin <strong>{immatriculation}</strong> n'a pas de catégorie définie.
                    Veuillez en sélectionner une pour continuer la validation du décaissement.
                </Text>
                <Select
                    style={{ width: "100%" }}
                    placeholder="Sélectionner une catégorie"
                    value={selectedCode}
                    onChange={setSelectedCode}
                    options={categories.map((c) => ({
                        value: c.codeCategorie,
                        label: `${c.codeCategorie} — ${c.nom}`,
                    }))}
                />
            </Space>
        </Modal>
    );
};

export default FixEnginCategorieModal;
